// extracted by mini-css-extract-plugin
export var nav = "Nav-module--nav--17vaI";
export var link = "Nav-module--link--2fVbB";
export var linkActive = "Nav-module--linkActive--FolJk";
export var wrapperico = "Nav-module--wrapperico--2kCqX";
export var ico = "Nav-module--ico--2Ekt_";